import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { User } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "../types";

interface NameFieldProps {
  form: UseFormReturn<FormValues>;
  isEditing: boolean;
}

export function NameField({ form, isEditing }: NameFieldProps) {
  const currentName = form.watch('full_name');

  if (!isEditing) {
    return (
      <Card className="transition-all duration-200 hover:shadow-md">
        <div className="p-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-primary/10 p-2.5">
              <User className="h-5 w-5 text-primary" />
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-muted-foreground">Full Name</p>
              <p className="text-sm font-medium">{currentName || "Not set"}</p>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card className="transition-all duration-200">
      <div className="p-6">
        <FormField
          control={form.control}
          name="full_name"
          rules={{
            required: "Full name is required",
            minLength: {
              value: 2,
              message: "Name must be at least 2 characters"
            }
          }}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Full Name</FormLabel>
              <FormControl>
                <div className="relative">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2">
                    <User className="h-4 w-4 text-muted-foreground" />
                  </div>
                  <Input 
                    placeholder="Enter your full name"
                    className="pl-10"
                    {...field}
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </Card>
  );
}